/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const ErrorCardRoot = styled('div')({
  '&&': {
    maxWidth: 600,
    margin: '0 auto',
    padding: 16,
    textAlign: 'center'
  }
});

const ErrorCardBody = styled(Typography)({
  '&&': {
    padding: '32px 0'
  }
});

const Details = ({ details, showDetails }) => (
  showDetails ? (
    <Typography component="div" variant="body1">
      {details}
    </Typography>
  ) : null
);

Details.propTypes = {
  showDetails: PropTypes.bool,
  details: PropTypes.oneOfType([
    PropTypes.node.isRequired,
    PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
  ])
};

Details.defaultProps = {
  showDetails: false,
  details: ''
};

/**
 * A component that displays errors.
 *
 * @author Hari Gangadharan
 */
const ErrorCard = (
  {
    title, body, details, showDetails, actions
  }
) => (
  <ErrorCardRoot>
    <Typography component="div" variant="h1">
      {title}
    </Typography>
    <ErrorCardBody component="div" variant="body1">
      {body}
    </ErrorCardBody>
    <Details showDetails={showDetails} details={details} />
    {actions}
  </ErrorCardRoot>
);

ErrorCard.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.node.isRequired,
    PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
  ]).isRequired,
  showDetails: PropTypes.bool,
  details: PropTypes.oneOfType([
    PropTypes.node.isRequired,
    PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
  ]),
  body: PropTypes.oneOfType([
    PropTypes.node.isRequired,
    PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
  ]).isRequired,
  actions: PropTypes.oneOfType([
    PropTypes.node.isRequired,
    PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
  ])
};

ErrorCard.defaultProps = {
  actions: null,
  showDetails: false,
  details: ''
};

export default ErrorCard;
